import { z } from 'zod';
import {
  ContactSubFormSchema,
  NonStandardToolsFieldSchema,
  OptionLabelValueSchema,
} from '../../utils/schemas';
import { TicketDetailForms } from '../DefinedFormTypes';

export const WiringCopperFormSchema = z.object({
  formType: z.literal(TicketDetailForms.enum.WiringCopper),

  whenDidIssueBegin: OptionLabelValueSchema,
  issueDescription: z.string().trim().nonempty('Required'),
  techToTestWith: z.discriminatedUnion('techToTestWith', [
    z.object({ techToTestWith: z.literal('Yes') }),
    z.object({ techToTestWith: z.literal('No') }),
  ]),
  itTestingContacts: z.array(ContactSubFormSchema),
  nonStandardTools: NonStandardToolsFieldSchema,
});

export type WiringCopperForm = z.infer<typeof WiringCopperFormSchema>;
